import React from 'react';
import { colours } from 'utils/theme';

const Optional = ({ children = 'OPTIONAL', style = {} }) => (
  <span
    style={{
      fontSize: 10,
      color: colours.grey,
      fontWeight: 400,
      marginLeft: 4,
      textTransform: 'none',
      ...style,
    }}
  >
    ({children})
  </span>
);

export default Optional;
